import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ComponentType} from 'react';
import {connect} from 'react-redux';

import {TSelectedParcel} from 'App/features/map2DEntities/selectedParcels/selectedParcelsTypes';
import {RootState} from 'App/store/rootReducer';

import {removeInvalidParcels} from './selectedParcelsUtils';

type TSelectedParcelsSlice = {
  parcels: TSelectedParcel[];
};

const initialState: TSelectedParcelsSlice = {
  parcels: [],
};

const selectedParcelsSlice = createSlice({
  name: 'selectedParcels',
  initialState,
  reducers: {
    toggleSelectedParcel: (
      state,
      {payload}: PayloadAction<TSelectedParcel>,
    ) => {
      state.parcels = removeInvalidParcels(state.parcels, payload);
    },
    resetSelectedParcels: state => {
      state.parcels = [];
    },
  },
});

const mapSelectedParcelsToProps = (state: RootState) => ({
  selectedParcels: state.map2DEntities.selectedParcels,
});
export const connectToSelectedParcels = (
  Component: ComponentType<{selectedParcels: {parcels: TSelectedParcel[]}}>,
): ComponentType =>
  connect(mapSelectedParcelsToProps, null, null, {forwardRef: true})(Component);

export const selectSelectedParcels = (state: RootState): TSelectedParcel[] =>
  state.map2DEntities.selectedParcels.parcels;

export const {toggleSelectedParcel, resetSelectedParcels} =
  selectedParcelsSlice.actions;

export default selectedParcelsSlice.reducer;
